import React, { FC } from 'react';
import { ColorFilterNode } from '../ColorFilterNode';
import styles from './AnyColorFilterNode.scss';
import { IOuter } from './AnyColorFilterNode.types';

export const AnyColorFilterNode: FC<IOuter> = ({ onClick, isSelected }) => (
  <ColorFilterNode onClick={onClick} isSelected={isSelected}>
    <span className={styles.circle} />
  </ColorFilterNode>
);
